import React, {useEffect, useState} from 'react';
import {ListItem, Slider} from "../../uiComponents";
import {Tab, Tabs} from "react-bootstrap";
import {connect} from "react-redux";
import { Empty } from 'antd';
import { useHistory } from "react-router-dom";
import {slugify} from "../../store/helper";


function renderTabs(dealTypes, dealTypesDetails, history) {

    function navigateToDeal(deal) {
        history.push(`/deal/${deal.requesturl}`, {
            ...deal
        });
    }

    if (!dealTypes) return null;
    return dealTypes.map((dealType, index) => {
        // if(dealTypesDetails && dealTypesDetails[dealType ? dealType.dealtypeId : '']){
        return (
            <Tab key={index}
                 tabClassName={`${slugify(dealType.name)}`}
                 eventKey={`${slugify(dealType.name)}`} title={dealType.name}>
                {dealTypesDetails[dealType.dealtypeId] ?
                    <ListItem
                        type="deal"
                        titleKey="name"
                        imageKey="imageformobile"
                        priceKey="price"
                        onClick={(selectedDeal) => navigateToDeal(selectedDeal)}
                        data={dealTypesDetails[dealType.dealtypeId]}/> :
                    <div className="empty-container">
                        <Empty/>
                    </div>}
            </Tab>
        )
        // }
        // return null
    });
}

function Deals(props) {
    const history = useHistory();
    const [tabActiveKey, setTabActiveKey] = useState('');
    const [filteredDealTypes, setFilteredDealTypes] = useState([]);
    const {dealTypes, dealTypesDetails, dealBanners} = props;

    useEffect(() => {
        let elem = document.getElementsByClassName(tabActiveKey)[0];
        elem && elem.click();
    }, [tabActiveKey]);

    useEffect(() => {

        let url = window.location.pathname;
        let getId = url.replace('/deals/', '');

        const data  = dealTypes.filter(obj => dealTypesDetails && dealTypesDetails[obj ? obj.dealtypeId : '']);

        if(getId != '/deals'){
            updateUrl(slugify(getId))
        } else {
            if(data && data.length){
                updateUrl(slugify(data[0].name));
            }
        }

        setFilteredDealTypes(data);

    }, []);


    const cursorFocus = function(elem) {

        let x = window.scrollX, y = window.scrollY;
        if(elem) elem.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });

        window.scrollTo(x, y);
    };

    const updateUrl = (id) => {
        if(id && !id.includes('/deals')) {
            window.history.pushState('', '', `/deals/${id}`);
            let elem = document.getElementsByClassName(id)[0];
            cursorFocus(elem);
            setTabActiveKey(id)
        }
    };


    return (
        <div className="deals">
            <Slider
                className="deals-slider"
                slides={dealBanners}/>
            <Tabs className="c-tab"
                  id="uncontrolled-tab-example"
                  onSelect={(key) => updateUrl(key)}
                  activeKey={tabActiveKey}>
                {renderTabs(filteredDealTypes, dealTypesDetails, history)}
            </Tabs>
        </div>
    );
}

const mapStateToProps = ({deals}) => {
    return {
        dealBanners: deals.dealbanners,
        dealTypes: deals.dealtypes,
        dealTypesDetails: deals.dealtypesdetails
    }
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Deals);
